export default {
    "domain": process.env.REACT_APP_AUTH0_DOMAIN,
    "clientId": process.env.REACT_APP_AUTH0_CLIENT_ID,
    "apiIdentifier": process.env.REACT_APP_AUTH0_API_IDENTIFIER,
    "logoutUrl": process.env.REACT_APP_AUTH0_LOGOUT_URL,
    "redirect": process.env.REACT_APP_AUTH0_REDIRECT,
    "responseType": 'token id_token',
    "scope": 'read:current_user update:current_user_metadata',
};
